import { IExperiment } from '../models/experiments';
import { ISearchPrice } from '../models/filters/price';
import { IUserGeo } from '../models/filters/user_geo';
import { IMainPage } from '../models/mainpage';

export const AB_ALLOWED_SEARCH_TYPES = ['buy', 'rent_short', 'rent_long'];
export const AB_ALLOWED_SECTIONS = ['index', 'sale', 'rent', 'daily-rent'];

export const AB_ALLOWED_SEARCH_TYPES_CHECKBOXES = ['buy'];
export const AB_ALLOWED_SECTIONS_CHECKBOXES = ['index', 'sale'];

export enum AB_NEWBUILDING_SEARCH_TABS_EXPERIMENTS {A = 0, B = 1, C = 2};

export const getABNewbuildingSearchTabs = (mainpage: IMainPage) => {
  const abNewbuildingSearchTabsExperiment =
    mainpage.experiments &&
    mainpage.experiments.find((experiment: IExperiment) => experiment.name === 'ab_newbuilding_search_tabs');

  return Boolean(abNewbuildingSearchTabsExperiment && abNewbuildingSearchTabsExperiment.abGroup);
};

export const getABNewbuildingSearchTabsBucket = (mainpage: IMainPage):
  undefined | AB_NEWBUILDING_SEARCH_TABS_EXPERIMENTS => {
  const abNewbuildingSearchTabsExperiment =
    mainpage.experiments &&
    mainpage.experiments.find((experiment: IExperiment) => experiment.name === 'ab_newbuilding_search_tabs');

  return abNewbuildingSearchTabsExperiment && abNewbuildingSearchTabsExperiment.abGroup;
};

function getRoomParam(room: string) {
  switch (room) {
    case '1':
      return 'room1=1';
    case '2':
      return 'room2=1';
    case '3':
      return 'room3=1';
    case '4':
      return 'room4=1';
    case '5':
      return 'room5=1';
    case '6':
      return 'room6=1';
    case 'studio':
      return 'room9=1';
    case 'free':
      return 'room7=1';
    default:
      return 'room1=1';
  }
}

function getPriceParams(price: ISearchPrice) {
  let param = '';
  let hasMinPrice = false;

  if (price.fromPrice) {
    param += `minprice=${price.fromPrice}`;
    hasMinPrice = true;
  }
  if (price.toPrice) {
    param = `${param}${hasMinPrice && '&'}maxprice=${price.toPrice}`;
  }

  return param.length ? `&${param}` : param;
}

export function parseParamsToNewbuildingUrl(rooms: string[], price: ISearchPrice, userGeo: IUserGeo) {
  let query = '';

  rooms.forEach(room => {
    query += `${getRoomParam(room)}&`;
  });

  query = query.substring(0, query.length - 1);

  query += getPriceParams(price);

  let region = '-1';

  if (userGeo.geoValue) {
    region = `${userGeo.geoValue}`;
  } else if (userGeo.userGeo) {
    region = `${userGeo.userGeo}`;
  }

  query += `&region=${region}`;

  return query;
};
